import React from 'react';
import { Checkbox } from 'antd';
import Text from 'components/Text/Text';

interface IProps {
	toggleIsCharityEnabled: () => void;
	isCharityEnabled: boolean;
}

export const IsCharityEnabledCheckBox: React.FC<IProps> = React.memo(({ toggleIsCharityEnabled, isCharityEnabled }) => {
	return (
		<div className="mb-2">
			<Checkbox data-test="IsCharityEnabledCheckBox" onChange={toggleIsCharityEnabled} checked={isCharityEnabled}>
				<Text translationNameSpace="form" translationKey="isCharityEnabledLabel" asFragment={true} />
			</Checkbox>
		</div>
	);
});
